// extracted by mini-css-extract-plugin
module.exports = {"blue50":"#3983ff","black20":"#d0d3d8"};